// extracted by mini-css-extract-plugin
export default {"searchWrapper":"HeaderSearch_searchWrapper__lMVKT","searchIcon":"HeaderSearch_searchIcon__Z2Zg0"};